import * as React from "react";

const FooterTrustItem = (props) => {
  const { url, childComp, openInNewTab = false } = props;
  
  const linkProps = openInNewTab 
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};
  
  return (
    <a 
      href={url} 
      style={{ 
        textDecoration: "none",
        transition: "all 0.2s ease-in-out"
      }} 
      {...linkProps}
      onMouseEnter={(e) => {
        e.target.style.transform = "translateY(-1px)";
        e.target.style.textDecoration = "none";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "translateY(0)";
      }}
    >
      <div
        className="text-center m-0 p-0"
        style={{ 
          color: "#212529", 
          fontFamily: "poppins", 
          fontSize: "16px",
          fontWeight: "600",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out"
        }}
      >
        {childComp}
      </div>
    </a>
  );
};

export default FooterTrustItem;